export default ({
  data,
  yKeys,
  xKey,
  title,
  showPercentage,
  legend,
  yAxis,
  rotationKey,
  paddingBottom,
  onClickGraph,
  height,
  colorLabel,
  colorTheme
}) => ({
  data: data || [],
  background: { visible: false },
  title: {
    text: title,
    color: colorLabel,
    fontFamily: 'Montserrat, sans-serif'
  },
  height: height,
  series: [
    {
      type: 'column',
      yKeys: yKeys || [''],
      xKey: xKey || '',
      strokes: 0,
      grouped: true,
      fills: colorTheme,
      highlightStyle: { fill: colorLabel },
      yNames: yKeys,
      listeners: {
        nodeClick: (param) => (onClickGraph ? onClickGraph(param) : () => {})
      }
    }
  ],
  axes: [
    {
      type: 'category',
      position: 'bottom',
      label: {
        color: colorLabel,
        rotation: rotationKey || 0,
        padding: rotationKey ? 10 : 5
      },
      tick: {
        width: 0
      }
    },
    {
      type: 'number',
      position: 'left',
      label: {
        color: colorLabel,
        formatter:
          showPercentage &&
          function (params) {
            return params.value + '%'
          }
      },
      title: yAxis
        ? {
            text: yAxis || 'Y Axis',
            color: colorLabel,
            fontFamily: 'Montserrat, sans-serif'
          }
        : null,
      tick: {
        width: 0
      }
    }
  ],
  padding: {
    top: 0,
    right: 5,
    bottom: paddingBottom || 20,
    left: 5
  },
  legend: {
    enabled: legend,
    color: colorLabel,
    position: 'bottom',
    markerSize: 10,
    fontFamily: 'Montserrat, sans-serif'
  }
})
